import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import {
    CART_ITEM_TYPE_PRODUCT, CartItem, CartSampling, SampleServiceItem,
    SupplyItem
} from '../../../model/cart.model';
import * as fromApp from '../../../store/app.reducers';
import * as CartActions from '../../../store/cart/cart.actions';
import { CatalogueService } from '../../../web-services/catalogue.service';
import {
    isInstanceOfProductNavigatable, IProduct,
    isInstanceOfProductDeletable, isInstanceOfProductFavoratable
} from '../../../model/contract/product.contract';
import { Router } from '@angular/router';
import { SamplingItem } from '../../../model/sampling-item/sampling-item.model';

@Component({
    selector: 'app-cart-item',
    templateUrl: './cart-item.component.html',
    styleUrls: ['./cart-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartItemComponent implements OnInit {
    @Input() cartItem: CartItem;
    @Input() last: boolean;
    @Input() unavailableItemsPresent: boolean;
    @Input() detailed = false;
    @Input() groupId: number;
    @Input() type: string;
    @Input() cartSampling: CartSampling;
    @Input() readonly = false;

    @Output() showDetail = new EventEmitter<IProduct>();

    deletable: boolean;
    favoratable: boolean;

    constructor(private store: Store<fromApp.AppState>,
        private catalogueService: CatalogueService,
        private router: Router) {
    }

    ngOnInit() {
        this.deletable =  isDeletable(this.cartItem);
        this.favoratable = isFavoratable(this.cartItem.item);
    }

    deleteCartItem() {
        const newItem = this.cartItem.clone();
        newItem.quantity = 0;
        this.cartItem = newItem;
        this.store.dispatch(new CartActions.UpdateCartItem(this.cartItem, this.cartSampling));
    }

    toProductPage() {
        if (isInstanceOfProductNavigatable(this.cartItem.item)) {
            this.showDetail.emit(this.cartItem.item);
        }
    }

    isProductType() {
        return this.type === CART_ITEM_TYPE_PRODUCT;
    }

    isPrepServiceItem(item: CartItem) {
        return item instanceof SampleServiceItem;
    }

    isSamplingSupplyItem(item: CartItem) {
        return item instanceof SupplyItem;
    }

    getItemPrice(cartItem: CartItem) {
    /* return this.isProductType()
      ? cartItem.quantityPrice // samplingSupply
      : cartItem.item.price; // analyticalTest*/

        return cartItem.quantityPrice;
    }
}

const isDeletable = (cartItem: CartItem) => isInstanceOfProductDeletable(cartItem.item) && cartItem.userAdded;

const isFavoratable = (item: IProduct) => isInstanceOfProductFavoratable(item);

